import { CALL_API, Schemas } from '../../common/middleware/api';

export const SELF_ASSESSMENTS_REQUEST = 'SELF_ASSESSMENTS_REQUEST';
export const SELF_ASSESSMENTS_SUCCESS = 'SELF_ASSESSMENTS_SUCCESS';
export const SELF_ASSESSMENTS_FAILURE = 'SELF_ASSESSMENTS_FAILURE';

export const SELF_ASSESSMENT_FETCH_REQUEST = 'SELF_ASSESSMENT_GET_REQUEST';
export const SELF_ASSESSMENT_FETCH_SUCCESS = 'SELF_ASSESSMENT_GET_SUCCESS';
export const SELF_ASSESSMENT_FETCH_FAILURE = 'SELF_ASSESSMENT_GET_FAILURE';

export const SELF_ASSESSMENT_UPDATE_REQUEST = 'SELF_ASSESSMENT_UPDATE_REQUEST';
export const SELF_ASSESSMENT_UPDATE_SUCCESS = 'SELF_ASSESSMENT_UPDATE_SUCCESS';
export const SELF_ASSESSMENT_UPDATE_FAILURE = 'SELF_ASSESSMENT_UPDATE_FAILURE';

export const loadSelfAssessments = (options) => ({
    [CALL_API]: {
        types: [SELF_ASSESSMENTS_REQUEST, SELF_ASSESSMENTS_SUCCESS, SELF_ASSESSMENTS_FAILURE],
        endpoint: 'api/selfAssessmentFormResponses',
        request: options,
        schema: Schemas.SELF_ASSESSMENT_ARRAY
    }
});

export const fetchSelfAssessment = (childId, formId) => (dispatch, getState) => {
    if (getState().entities.selfAssessments[`${childId}|${formId}`]) {
        return null;
    }

    dispatch({
        [CALL_API]: {
            types: [SELF_ASSESSMENT_FETCH_REQUEST, SELF_ASSESSMENT_FETCH_SUCCESS, SELF_ASSESSMENT_FETCH_FAILURE],
            endpoint: `api/selfAssessmentFormResponses`,
            request: { childId, formId },
            schema: Schemas.SELF_ASSESSMENT
        }
    });
};

export const updateSelfAssessment = ({ childId, formId, ...rest }, onSuccess, onError) => ({
    [CALL_API]: {
        types: [SELF_ASSESSMENT_UPDATE_REQUEST, SELF_ASSESSMENT_UPDATE_SUCCESS, SELF_ASSESSMENT_UPDATE_FAILURE],
        endpoint: `api/selfAssessmentFormResponses`,
        method: 'PUT',
        request: { childId, formId, ...rest },
        schema: Schemas.SELF_ASSESSMENT,
        form: 'customForm',
        onSuccess,
        onError
    }
});
